import React from "react";
import PropTypes from 'prop-types';
import AnimateOnScroll from '../components/AnimateOnScroll';
import Bullet from '../components/Bullet';
import { useLanguage } from '../providers/LanguageProvider';

const Audience = ({ id }) => {
  const { translations } = useLanguage();
  
  return (
  <section id={id} className="relative bg-cream py-16 md:py-24">
    
    <div className="relative z-10 mx-auto max-w-[1220px] px-6">
      <div className="text-start">
        <AnimateOnScroll>
          <h3 className="text-2xl md:text-3xl font-extrabold text-mocha text-center">{translations.audience.title}</h3>
        </AnimateOnScroll>
        <AnimateOnScroll delay={300}>
          <div className="mt-10 lg:me-36">
            <p className="ms-3 text-lg font-bold">{translations.audience.subtitle}</p>
            <ul className="mt-6 space-y-3 text-lg">
              {translations.audience.points.map((point, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="flex-shrink-0"><Bullet /></div>
                  <div>{point}</div>
                </li>
              ))}
            </ul>
          </div>
        </AnimateOnScroll>
        <AnimateOnScroll delay={600}>
          <h3 className="mt-10 text-lg md:text-xl font-extrabold text-center tracking-normal md:tracking-widest leading-loose">{translations.audience.closing}</h3>
        </AnimateOnScroll>
      </div>
    </div>
  </section>
  );
};

Audience.propTypes = {
  id: PropTypes.string,
};

export default Audience;